const clone = (value) => JSON.parse(JSON.stringify(value));

/** Index layout entries by id (panels and extensions). */
export const indexById = (entries = []) => entries.reduce((acc, entry) => {
	if (entry && entry.id) {
		acc[entry.id] = entry;
	}
	return acc;
}, {});

/** Find a node with the given id in a tree (panel or widget). */
export const findById = (node, id) => {
	if (!node) {
		return null;
	}
	if (node.id === id) {
		return node;
	}
	const children = node.children || [];
	for (let i = 0; i < children.length; i++) {
		const found = findById(children[i], id);
		if (found) {
			return found;
		}
	}
	return null;
};

/**
 * Merge an extension into a base tree.
 * Extension children that themselves are extensions patch named nodes;
 * other children are appended to the target node's children.
 */
export const mergeExtension = (tree, extension) => {
	const next = clone(tree);
	const ops = extension.children || [];
	ops.forEach((op) => {
		if (op.type === 'extension' && op.extending) {
			const target = findById(next, op.extending);
			if (!target) {
				return;
			}
			target.children = [].concat(target.children || [], clone(op.children || []));
			return;
		}
		// bare widgets/panels under extension: append to root
		next.children = [].concat(next.children || [], [clone(op)]);
	});
	return next;
};

/**
 * Resolve a layout id to a concrete panel tree.
 * Follows extension → extending until a panel root is produced.
 */
export const resolve = (entries, id) => {
	const index = indexById(entries);
	const entry = index[id];
	if (!entry) {
		return null;
	}
	if (entry.type === 'panel') {
		return clone(entry);
	}
	if (entry.type === 'extension' && entry.extending) {
		const base = resolve(entries, entry.extending);
		if (!base) {
			return null;
		}
		return mergeExtension(base, entry);
	}
	return clone(entry);
};

export default {
	clone,
	indexById,
	findById,
	mergeExtension,
	resolve
};
